import React from 'react';
import { Helmet } from 'react-helmet';
const Contact = () => {

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Contact Us - Mauli Cabs",
    "url": "https://www.maulicabs.in/contact-us",
    "description": "Get in touch with Mauli Cabs for bookings, inquiries, or customer support. Reach us by phone, email, or through our online contact form for all your Mumbai to Pune travel needs."
  };



  return (
    <>
      <Helmet>
        <title>Contact Us | Mauli Cabs | Mumbai to Pune Taxi</title>
        <meta
          name="description"
          content="Need assistance? Contact Mauli Cabs for bookings, inquiries, or any questions related to your Mumbai to Pune taxi service. We're here to help with your travel needs."
        />
        <meta
          name="keywords"
          content="contact mauli cabs, mauli cabs customer service, taxi booking inquiries, mauli cabs support, mumbai pune cab contact, mauli cabs phone number, mauli cabs email, taxi service contact mumbai, cab booking helpline, mumbai to pune cab service contact"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

      {/* Breadcrumb */}
      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Contact Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="pt-5 pb-5">
        <div className="container">
          {/* Contact Cards */}
          <div className="row justify-content-between g-4 mb-5">
            {/* Call Us */}
            <div className="col-12 col-md-4">
              <div className="card p-4 rounded-4 border text-center h-100 bg-orangee">
                <div className="crds-icons d-inline-flex mx-auto mb-3 fs-2" style={{ color: '#631D02' }}>
                  <i className="fa-solid fa-headset"></i>
                </div>
                <div className="crds-desc">
                  <h5 className="mb-3 text-white">Call Us</h5>
                  <p className="mb-1">
                    <a href="tel:+917972733209" className="text-decoration-none text-white">
                      +91 7972733209
                    </a>
                  </p>
                  <p className="mb-0">
                    <a href="tel:+919763272775" className="text-decoration-none text-white">
                      +91 9763272775
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Drop a Mail */}
            <div className="col-12 col-md-4">
              <div className="card p-4 rounded-4 border text-center h-100 bg-orangee">
                <div className="crds-icons d-inline-flex mx-auto mb-3 fs-2" style={{ color: '#631D02' }}>
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="crds-desc">
                  <h5 className="mb-3 text-white">Drop a Mail</h5>
                  <p className="mb-0">
                    <a href="mailto:booking@maulicabs.com" className="text-decoration-none text-white">
                      booking@maulicabs.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="col-12 col-md-4">
              <div className="card p-4 rounded-4 border text-center h-100 bg-orangee">
                <div className="crds-icons d-inline-flex mx-auto mb-3 fs-2" style={{ color: '#631D02' }}>
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="crds-desc">
                  <h5 className="mb-2 text-white">Address</h5>
                  <h6 className="fw-semibold text-white">Mauli Cabs</h6>
                  <p className="mb-0 text-white">
                    Pune Alandi Road, Wadmukkhwadi Charholi Bk, Alandi Devachi, Khed, Pune 412105
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="row">
            <div className="col-12">
              <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '450px' }}>

                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5974.581473234213!2d73.904111!3d18.680306000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c89b7a5bddd5%3A0xabd442a1f59f09e9!2sShri%20Nakoda%20Parshwanath%20Temple!5e1!3m2!1sen!2sin!4v1745663651407!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

              </div>

              <br /><br />

              <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '450px' }}>

                <div>
                  <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3154.554924689206!2d73.89950727519565!3d18.68371498244178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDQxJzAxLjQiTiA3M8KwNTQnMDcuNSJF!5e1!3m2!1sen!2sin!4v1746270646774!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>





            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
